import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import RestaurantCard from "./RestaurantCard";
import PaginationControls from "../common-component/PaginationControls";

const RestaurantList = ({
  restaurants,
  countryId,
  hasMore,
  onNextPage,
  onPrevPage,
  offset,
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      {restaurants?.length === 0 ? (
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Poppins, sans-serif",
            textAlign: "center",
            my: 4,
          }}
        >
          No restaurants found
        </Typography>
      ) : (
        <>
          <Grid
            container
            spacing={3}
            sx={{
              justifyContent: { xs: "center", sm: "flex-start" },
              "& > .MuiGrid-item": {
                display: "flex",
                justifyContent: "center",
              },
            }}
          >
            {restaurants?.map((restaurant) => (
              <Grid item key={restaurant._id} xs={12} sm={6} md={6} lg={4}>
                <RestaurantCard restaurant={restaurant} countryId={countryId} />
              </Grid>
            ))}
          </Grid>
          <Box sx={{ mt: 4, mb: 2, display: "flex", justifyContent: "center" }}>
            <PaginationControls
              hasMore={hasMore}
              onNextPage={onNextPage}
              onPrevPage={onPrevPage}
              offset={offset}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default RestaurantList;
